import { DEFAULT_TEXT_STYLE, chartColorPalette } from '../ChartWidget.config';
import { extendSeriesData } from '../ChartWidget.helpers';
import { ChartDataSeries } from '../ChartWidget.types';

const DEFAULT_WIDTH = 500;
const DEFAULT_HEIGHT = 350;

const DEFAULT_BORDER_WIDTH = 0;
const DEFAULT_BORDER_COLOR = '#FFF';
const DEFAULT_COLUMN_CHART_SINGLE_SERIES_DATA = {
  legend: {
    enabled: false,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  seriesData: extendSeriesData([
    {
      name: 'Industries',
      data: ['Public Sector', 'Education', 'Technology', 'Financial Services', 'Consumer Products'],
    },
    {
      name: 'Organizations',
      data: [950, 620, 410, 270, 60],
    },
  ] as ChartDataSeries),
  seriesMeta: {
    colors: chartColorPalette,
  },
  xAxis: {
    title: {
      text: 'Industries',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    style: {
      lineColor: '#000000',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  yAxis: {
    title: {
      text: 'Organizations',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    style: {
      lineColor: '#000000',
      lineWidth: 1,
    },
    enableLine: false,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  grid: {
    style: {
      lineColor: '#e6e6e6',
    },
  },
  generalOptions: {
    innerSize: 0,
    borderWidth: DEFAULT_BORDER_WIDTH,
    borderColor: DEFAULT_BORDER_COLOR,
  },
  patterns: {
    enabled: false,
    list: [],
  },
};

const DEFAULT_COLUMN_CHART_MULTI_SERIES_DATA = {
  legend: {
    enabled: true,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  seriesData: extendSeriesData([
    {
      data: ['Public Sector', 'Education', 'Technology'],
    },
    {
      name: '2010',
      data: [18, 12, 6],
    },
    {
      name: '2020',
      data: [24, 16, 8],
    },
    {
      name: '2030',
      data: [30, 20, 10],
    },
  ] as ChartDataSeries),
  seriesMeta: {
    colors: chartColorPalette,
  },
  xAxis: {
    title: {
      text: 'Industries',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    style: {
      lineColor: '#000000',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  yAxis: {
    title: {
      text: 'Percentage of organizations',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    style: {
      lineColor: '#000000',
      lineWidth: 1,
    },
    enableLine: false,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  grid: {
    style: {
      lineColor: '#e6e6e6',
    },
  },
  generalOptions: {
    innerSize: 0,
    borderWidth: DEFAULT_BORDER_WIDTH,
    borderColor: DEFAULT_BORDER_COLOR,
  },
  patterns: {
    enabled: false,
    list: [],
  },
};

export {
  DEFAULT_HEIGHT,
  DEFAULT_WIDTH,
  DEFAULT_BORDER_WIDTH,
  DEFAULT_BORDER_COLOR,
  DEFAULT_COLUMN_CHART_MULTI_SERIES_DATA,
  DEFAULT_COLUMN_CHART_SINGLE_SERIES_DATA,
};
